// extracted by mini-css-extract-plugin
export default {"container":"JustCoverBook_container__ThrGs"};